function buildRouteUrl(
  baseUrl: string,
  queries?: { name: string; value: string }[]
): string {
  let paramsCount = 0;
  const params = new URLSearchParams();

  queries &&
    queries.forEach(query => {
      if (query.value) {
        params.append(query.name, query.value);
        paramsCount += 1;
      }
    });

  if (paramsCount > 0) return `${baseUrl}?${params}`;

  return baseUrl;
}

export default buildRouteUrl;
